import { derivePriorDateRange } from 'features/filters/prior-date-range'
import { type FilterOption, FilterOptionDate } from 'features/filters/types'
import { HardcodedFilterOptionsEnum } from 'features/filters/utils/helpers'
import { DateWindows, Filters } from 'types/project'

type Props = {
  filters: Filters
  dateWindows: DateWindows
  defaultFilterList: FilterOption[]
  prevIsDelta: boolean
}
export const usePrevFilters = ({
  filters,
  dateWindows,
  defaultFilterList,
  prevIsDelta,
}: Props): {
  newDelta: boolean
  dateFilter: FilterOptionDate | undefined
  prevFilters: Filters
  prevDateIsBeforeFirstReview: boolean
} => {
  const prevFilters: Filters = JSON.parse(JSON.stringify(filters || {}))
  let newDelta = prevIsDelta
  let prevDateIsBeforeFirstReview = false

  // TODO THIS IS DUPLICATED CODE  -  DisplayWidget.270
  let dateFilter = prevFilters?.values?.find(
    ({ field }) => field === HardcodedFilterOptionsEnum.CREATE_TIME,
  ) as FilterOptionDate | undefined

  if (dateFilter) {
    const { range, isBeforeFirstReview } = derivePriorDateRange(
      { min: dateFilter.min, max: dateFilter.max },
      dateWindows,
      defaultFilterList,
    )
    if (range) {
      dateFilter.min = range.min
      dateFilter.max = range.max
    } else if (isBeforeFirstReview) {
      dateFilter = undefined
      // we can't calculate a delta against a time period that doesn't exist
      newDelta = false
      prevDateIsBeforeFirstReview = true
    }
  }

  return { newDelta, dateFilter, prevFilters, prevDateIsBeforeFirstReview }
}
